import React from 'react'

export const TitleH2 = ({name, className}) => {
  return (
    <div>
        <h2 className={className}>{name}</h2>
    </div>
  )
}
